module.exports = __webpack_public_path__ + "assets/star.2ee70ca12681f1f40b579443a013415c.png";


/*****************
 ** WEBPACK FOOTER
 ** ./img/star.png
 ** module id = 215
 ** module chunks = 0
 **/